import Vue from 'vue';
import api from '../../api/emailSuppressions';
import * as types from '../mutation-types';

const T = types.default;

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isDeleting: false,
    isImporting: false,
  },
};

export const getters = {
  getSuppressions: $state => Object.values($state.records),
  getSuppression: $state => id => $state.records[id],
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetch({ commit }, params = {}) {
    commit(T.SET_EMAIL_SUPPRESSION_UI_FLAG, { isFetching: true });
    try {
      const { data } = await api.list(params);
      commit(T.SET_EMAIL_SUPPRESSIONS, data);
      return data;
    } finally {
      commit(T.SET_EMAIL_SUPPRESSION_UI_FLAG, { isFetching: false });
    }
  },
  async delete({ commit }, id) {
    commit(T.SET_EMAIL_SUPPRESSION_UI_FLAG, { isDeleting: true });
    try {
      await api.delete(id);
      commit(T.REMOVE_EMAIL_SUPPRESSION, id);
    } finally {
      commit(T.SET_EMAIL_SUPPRESSION_UI_FLAG, { isDeleting: false });
    }
  },
  async importCsv({ commit, dispatch }, file) {
    commit(T.SET_EMAIL_SUPPRESSION_UI_FLAG, { isImporting: true });
    try {
      const { data } = await api.importCsv(file);
      await dispatch('fetch');
      return data;
    } finally {
      commit(T.SET_EMAIL_SUPPRESSION_UI_FLAG, { isImporting: false });
    }
  },
};

export const mutations = {
  [T.SET_EMAIL_SUPPRESSIONS]($state, list) {
    $state.records = (list || []).reduce(
      (acc, s) => ({ ...acc, [s.id]: s }),
      {}
    );
  },
  [T.REMOVE_EMAIL_SUPPRESSION]($state, id) {
    Vue.delete($state.records, id);
  },
  [T.SET_EMAIL_SUPPRESSION_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
